import accessRequest from './accessRequest'
import profile from './profile'

const namespaced = true

export default {
  namespaced,
  modules: {
    accessRequest,
    profile
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client/forms/index.js